import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Col, Tab, Nav, Navbar } from "react-bootstrap";
import TopHeader from "../navbar/TopHeader";
import LogInFooter from "../logincomponent/LogInFooter";
import AddRegaddress from "../component/AddRegaddress";
import NavMcp from "../component/NavMcp";
import TopBar from "../navbar/TopBar";

const AddRegistered = ({}) => {
  const location = useLocation();
  // console.log("loc", location);
  return (
    <div className="mcp-page">
      <TopBar />
      <TopHeader type="addreg" />
      <div className="m-2 d-flex-wrap  ">
        <Col xl={2} lg={3} md={4} xs={12} className="px-2 my-2">
          <Nav variant="pills" className="flex-column nav_mctap">
            <Nav.Item>
              <Nav.Link eventKey="inform" className="active">
                <Link to="/mcprofile" className="nav-link">
                  {" "}
                  Basic Information{" "}
                </Link>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="transport">
                <Link to="/mcprofile/transport" className="nav-link">
                  {" "}
                  Nearest Transport Points{" "}
                </Link>{" "}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="certificate">
                <Link to="/mcprofile/certificate" className="nav-link">
                  Certificate/Awards{" "}
                </Link>
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Col>
        <Col lg={7} md={8} xs={12} className="px-3 my-2">
          <AddRegaddress zoomLevel={"zoomLevel"} location={location} />
        </Col>
      </div>

      <div className="rg-footer">
        <LogInFooter />
      </div>
    </div>
  );
};
export default AddRegistered;
